exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-container{position:relative}.date-container:hover .date-content{visibility:visible;opacity:1}.date-content{visibility:hidden;opacity:0;transition:all .3 linear;position:absolute;top:-10px;right:130px;z-index:1000;background-color:#fff;border:1px solid #e4e7ed;border-radius:6px!important;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);padding:8px 12px;width:270px}.popover-arrow{position:absolute;top:25px;right:-7px;z-index:3000;height:13px;width:13px;border-radius:0;border:1px solid #e4e7ed;background:#fff;transform:rotate(135deg);border-bottom:none;border-right:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1464d2e0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewOrderDates.vue
// module id = 1636
// module chunks = 0